// =============================================================================
// TickAndPass Shared Legal Configuration
// =============================================================================
// The legal details shared by the web (packages/frontend) and the app
// (packages/mobile). The Terms & Conditions and Privacy Policy texts live on
// the website alone (pages/TermsPage.jsx, PrivacyPage.jsx); the app shows
// those pages inside itself (mobile screens/legal, ticket T&P-34), so a
// change to them reaches the app without an app update.
// =============================================================================

export const LEGAL_CONFIG = Object.freeze({
  companyName: "Tick and Pass Services Private Limited",
  effectiveDate: "August 1, 2026",
  lastUpdated: "August 24, 2026",
  privacyLastUpdated: "October 2, 2026",
  supportEmail: "support@tickandpass.com",
  privacyEmail: "privacy@tickandpass.com",
  businessAddress:
    "24/SF1 & 63/SF1, Indira Gandhi Street, Kaveri Rangan Nagar, Saligramam, Chennai - 600093, Tamil Nadu",
  websiteUrl: "https://test.tickandpass.com/",
  termsVersion: "1.0",
  privacyVersion: "1.1",
});
